import * as React from 'react'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { ICredit } from '../../../Model/Questionnaire'
import { inject, observer } from 'mobx-react'
import CreditDetailView from '../Questionnaire/CreditDetailView'

export interface ICreditViewProps {
    className?: string
    credit: ICredit
    localizationStore?: LocalizationStore
    anonymousView?: boolean
}

@inject('localizationStore')
@observer
export default class CreditView extends React.Component<ICreditViewProps> {
    render() {
        const { credit, localizationStore, anonymousView } = this.props

        return (
            <div className={this.props.className}>
                <div className="row">
                    <div className="col-12 col-sm-3 col-md-2 col-lg-2">
                        <span className="orderNumber">
                            № {credit.creditNumber
                                ? credit.creditNumber
                                : localizationStore!.t('no credit number')}
                        </span>
                    </div>
                    <CreditDetailView
                        className="col-12 col-sm-9 col-md-4 col-lg-5 blockCreditDetail"
                        creditDetail={credit.creditDetail}
                    />
                    <div
                        hidden={!anonymousView}
                        className="col-12 col-sm-12 col-md-6 col-lg-5"
                    >
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-5">
                                <span>
                                    {`${localizationStore!.t('creditPercentPerMonth')}: ` +
                                        `${credit.creditCondition.creditPercentPerMonth} %`}
                                </span>
                            </div>

                            <div className="col-12 col-sm-12 col-md-12 col-lg-7">
                                <span>
                                    {`${localizationStore!.t('creditPercentDiscountPerMonth')}: ` +
                                        `${credit.creditCondition.creditPercentDiscountPerMonth} %`}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Credit/CreditView.tsx